"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useRoomNumberInputProps = void 0;
var React = _interopRequireWildcard(require("react"));
var _useActions = require("../useActions");
var _reactRedux = require("react-redux");
var _selectors = require("../../../../selectors");
var _intOnly = require("../../../../utils/formatters/intOnly");
var _throttleDebounce = require("throttle-debounce");
var _types = require("../../../../actions/filters/types");
var _tracking = require("./tracking");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable react-hooks/rules-of-hooks */

const useRoomNumberInputProps = _ref => {
  let {
    isMyHome,
    withRoomNumber
  } = _ref;
  if (!isMyHome || !withRoomNumber) {
    return undefined;
  }
  const {
    flatNumber,
    flatNumberSuggest: {
      isSuccess
    },
    errorTooltip,
    estimationTarget,
    area,
    roomsCount
  } = (0, _reactRedux.useSelector)(_selectors.selectFilters);
  const {
    setFlatNumber,
    setIsMyHomeWidget,
    setWithRoomNumberWidget,
    getFlatNumberSuggest
  } = (0, _useActions.useActions)();

  /** Если есть ошибка, отобразится над инпутом фильтра */
  const errorMessage = errorTooltip.currentErrorField === _types.ECurrentErrorField.flatNumber ? errorTooltip.errorText : '';
  const getFlatNumberSuggestDebounced = React.useCallback((0, _throttleDebounce.debounce)(200, getFlatNumberSuggest), []);
  const onBlur = React.useCallback(() => {
    if (isSuccess) {
      (0, _tracking.submitAnalytics)({
        flatNumber,
        area,
        roomsCount
      });
    }
  }, [isSuccess, flatNumber, roomsCount, area, _tracking.submitAnalytics]);
  const onValueChange = React.useCallback(value => {
    const intVal = (0, _intOnly.intOnly)(value);
    setFlatNumber({
      flatNumber: Number(intVal)
    });
    getFlatNumberSuggestDebounced(String(intVal));
  }, [getFlatNumberSuggestDebounced, setFlatNumber, estimationTarget]);

  // Если выполнен IF сверху - значит всегда true
  React.useEffect(() => {
    setIsMyHomeWidget(true);
    setWithRoomNumberWidget(true);
  }, []);
  return {
    value: flatNumber ? String(flatNumber) : '',
    isRoomSuggestSuccess: isSuccess,
    errorMessage,
    onValueChange,
    onBlur
  };
};
exports.useRoomNumberInputProps = useRoomNumberInputProps;